/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyConsumptionCip } from './energyConsumptionCip';


export interface StatusCodeValueEnergyConsumptionCip { 
    value?: EnergyConsumptionCip;
    status_code?: number;
}

